<template>
    <div>
        <MeasurementItem
            v-if="temperature"
            :title="temperature.title"
            :datetime="temperature.lastUpdated"
            :link-to="temperature.link"
        >
            <template #icon>
                <ThermometerIcon width="24" height="24" />
            </template>

            <template #content>
                {{ $t('shared.measurements.temperature') }}:

                <h3 class="sensor-data-temperature">
                    {{ temperature.value }}
                </h3>
            </template>
        </MeasurementItem>

        <MeasurementItem
            v-if="operator"
            :title="operator.title"
            :datetime="operator.lastUpdated"
        >
            <template #icon>
                <MonitorSignalIcon width="24" height="24" />
            </template>

            <template #content>
                {{ $t('operator') }}:

                <h3>{{ operator.value }}</h3>
            </template>
        </MeasurementItem>

        <MeasurementItem
            v-if="signal"
            :title="signal.title"
            :datetime="signal.lastUpdated"
            :link-to="signal.link"
        >
            <template #icon>
                <WifiSignalIcon width="24" height="24" />
            </template>

            <template #content>
                {{ $t('signal') }}:

                <h3>{{ signal.value }} dBm</h3>
            </template>
        </MeasurementItem>

        <MeasurementItem
            v-if="network"
            :title="network.title"
            :datetime="network.lastUpdated"
        >
            <template #icon>
                <NetworkSignalIcon width="24" height="24" />
            </template>

            <template #content>
                {{ $t('network') }}:

                <h3>{{ network.value }}</h3>
            </template>
        </MeasurementItem>

        <MeasurementItem
            v-if="connection"
            :title="connection.title"
            :datetime="connection.lastUpdated"
        >
            <template #icon>
                <SignalHighIcon width="24" height="24" />
            </template>

            <template #content>
                {{ $t('connection') }}:

                <h3>{{ connection.value }}</h3>
            </template>
        </MeasurementItem>

        <MeasurementItem
            v-if="wan"
            :title="wan.title"
            :datetime="wan.lastUpdated"
        >
            <template #icon>
                <NetworkPinIcon width="24" height="24" />
            </template>

            <template #content>
                {{ $t('wan') }}:

                <h3>{{ wan.value }}</h3>
            </template>
        </MeasurementItem>

        <MeasurementItem
            v-if="runningTime"
            :title="runningTime.title"
            :datetime="runningTime.lastUpdated"
            :link-to="runningTime.link"
        >
            <template #icon>
                <StopwatchIcon width="24" height="24" />
            </template>

            <template #content>
                {{ $t('runningTime') }}:

                <h3>
                    {{ runningTime.textDuration }}
                </h3>
            </template>
        </MeasurementItem>
    </div>
</template>

<script>
import { formatHelper } from '../utils'
import MeasurementItem from './MeasurementItem'
import MeasurementListHelper from '../mixins/MeasurementListHelper'
import MonitorSignalIcon from './icons/MonitorSignalIcon'
import NetworkPinIcon from './icons/NetworkPinIcon'
import NetworkSignalIcon from './icons/NetworkSignalIcon'
import SignalHighIcon from './icons/SignalHighIcon'
import StopwatchIcon from './icons/RefreshArrowsIcon'
import ThermometerIcon from './icons/ThermometerIcon'
import WifiSignalIcon from './icons/WifiSignalIcon'

export default {
    name: 'TeltonikaRouterMeasurement',
    components: {
        MeasurementItem,
        MonitorSignalIcon,
        NetworkPinIcon,
        NetworkSignalIcon,
        SignalHighIcon,
        StopwatchIcon,
        ThermometerIcon,
        WifiSignalIcon,
    },
    mixins: [MeasurementListHelper],
    computed: {
        connection() {
            return this.getMeasurementItem('connection')
        },
        operator() {
            return this.getMeasurementItem('operator')
        },
        network() {
            return this.getMeasurementItem('network')
        },
        runningTime() {
            const item = this.getMeasurementItem('running_time')
            if (item) {
                item.textDuration = formatHelper.hoursAndMinutesDuration(
                    item.value
                )
            }
            return item
        },
        signal() {
            return this.getMeasurementItem('signal')
        },
        state() {
            return this.getMeasurementItem('d1')
        },
        temperature() {
            return this.getMeasurementItem('temperature')
        },
        wan() {
            return this.getMeasurementItem('wan')
        },
    },
}
</script>

<i18n>
{
    "en": {
        "connection": "Connection",
        "network": "Network",
        "operator": "Operator",
        "runningTime": "Operating hours",
        "signal": "Signal",
        "wan": "WAN IP"
    },
    "de": {
        "connection": "Connection",
        "network": "Netzwerk",
        "operator": "Operator",
        "runningTime": "Betriebsstunden",
        "signal": "Signal",
        "wan": "WAN IP"
    },
    "fr": {
        "connection": "Connexion",
        "network": "Réseau",
        "operator": "Opérateur",
        "runningTime": "Heures de fonctionnement",
        "signal": "Signal",
        "wan": "WAN IP"
    },
    "it": {
        "connection": "Connection",
        "network": "Rete",
        "operator": "Operator",
        "runningTime": "Ore di funzionamento",
        "signal": "Signal",
        "wan": "WAN IP"
    }
}
</i18n>
